'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchMovements = exports.movementByAlias = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _sagaTools = require('@classpass/saga-tools');

var _universalFetch = require('../../../universal-fetch');

var _universalFetch2 = _interopRequireDefault(_universalFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleResponse = function handleResponse(res) {
  if (res.status >= 200 && res.status < 300) {
    return res;
  }
  var error = new Error(res.statusText);
  error.code = res.status;
  throw error;
};

var movementByAlias = exports.movementByAlias = (0, _sagaTools.makeEntityScaffold)('SAGA.FETCH.MOVEMENT_BY_ALIAS', function (alias) {
  if (__SERVER__) {
    var _require = require('../../../../server/handlers/fitness-library'),
        getMovementByAlias = _require.getMovementByAlias;

    return getMovementByAlias(alias);
  }

  return (0, _universalFetch2.default)('/_fitlib/movements/' + alias).then(handleResponse).then(function (res) {
    return res.json();
  });
}, { defaultKey: 0 });

var searchMovements = exports.searchMovements = (0, _sagaTools.makeEntityScaffold)('SAGA.FETCH.SEARCH_MOVEMENTS', function (aliasList) {
  if (__SERVER__) {
    var _require2 = require('../../../../server/handlers/fitness-library'),
        localSearchMovements = _require2.searchMovements;

    return localSearchMovements(aliasList);
  }

  return (0, _universalFetch2.default)('/_fitlib/movements/search', {
    method: 'POST',
    body: (0, _stringify2.default)({ movements: aliasList }),
    headers: { 'Content-type': 'application/json' }
  }).then(handleResponse).then(function (res) {
    return res.json();
  });
}, { defaultKey: function defaultKey(aliasList) {
    return aliasList.join('_');
  } });